// Content sourced from baheti.co + user-provided updates
export const COMPANY = {
  name: "BAHETI STEEL TRADERS",
  legalName: "BAHETI STEEL TRADERS LLP",
  tagline: "Your Trusted TMT Distributor",
  foundedYear: 1969,
  legacyYears: 56,
  phone: "+91 95335 61060",
  email: "info@baheti.co",
  address: "3-1-336, Esamiya Bazar, Koti, Hyderabad, 27",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_steel-3d-portal/artifacts/6u36c0fw_FESTIVAL%20GREETING.png",
  socials: {
    instagram: "https://www.instagram.com/bahetisteel/",
    facebook: "https://www.facebook.com/BahetiSteels",
    twitter: "https://twitter.com/BahetiSteel",
  },
};

// 6 brands — SHRISHTII & SUGNA removed per request
export const BRANDS = [
  { name: "RADHA 550", price: 63.5, grade: "Fe 550D", sizes: "8 – 32 mm" },
  { name: "SHREE", price: 63.5, grade: "Fe 500", sizes: "8 – 32 mm" },
  { name: "RADHA RHINO 600+", price: 64.5, grade: "Fe 600", sizes: "8 – 32 mm" },
  { name: "SARWOTTAM", price: 64.5, grade: "Fe 550", sizes: "8 – 32 mm" },
  { name: "JAIRAJ", price: 66.5, grade: "Fe 550D", sizes: "8 – 40 mm" },
  { name: "TATA", price: 80.75, grade: "Fe 500D", sizes: "8 – 32 mm" },
];

export const BUILDERS = [
  "Engineers Associates Private Limited",
  "DSR SR Prime Spaces LLP",
  "RB Ghodke Infrastructure Private Limited",
  "Shresta Properties",
  "Rajpushpa Properties Private Limited",
  "Inventa Industries Private Limited",
  "Janapriya Properties Private Limited",
  "Ashoka Builders India Private Limited",
  "Gurunanak Institute",
  "Divisree Constructions",
  "Cherabuddi Education Society",
  "Vajram Constructions",
  "Sumadhura Constructions Private Limited",
  "Namishree Infra",
  "Trupti SPN Cables",
  "Antelope Projects",
  "PVR Developers",
  "Megha Infra",
  "Oil Country Tubular Limited",
  "Kakaji Towers",
  "United Steel Allied Industries Private Limited",
];

export const BRANCHES = [
  {
    name: "BAHETI STEEL TRADERS LLP",
    address: "3-1-336, Esamiya Bazar, Koti, Hyderabad, 27.",
    phone: "+91 95335 61060",
    email: "info@baheti.co",
    coords: [17.3789, 78.4853],
    mapsQuery: "Baheti+Steel+Traders+Esamiya+Bazar+Koti+Hyderabad",
  },
  {
    name: "BAHETI STEEL INDUSTRIES",
    address: "11/3, Baba Nagar, Nacharam, Secunderabad, 76.",
    phone: "+91 93939 45252",
    email: "info@baheti.co",
    coords: [17.4264, 78.5510],
    mapsQuery: "Baba+Nagar+Nacharam+Secunderabad",
  },
  {
    name: "BAHETI STEEL CORPORATION",
    address: "6-6-46, Inner Ring Rd, Katedhan, 52.",
    phone: "+91 99639 10585",
    email: "info@baheti.co",
    coords: [17.3173, 78.5078],
    mapsQuery: "Katedhan+Inner+Ring+Road+Hyderabad",
  },
  {
    name: "BAHETI STEELS",
    address: "Mohan Nagar, Bairamalguda, 74.",
    phone: "+91 93930 00632",
    email: "info@baheti.co",
    coords: [17.3186, 78.5360],
    mapsQuery: "Mohan+Nagar+Bairamalguda+Hyderabad",
  },
];

export const TIMELINE = [
  { year: "1969", title: "Foundation", text: "Baheti Steel Traders opens its doors in Esamiya Bazar, Hyderabad — founded by late Shri Motilal Baheti." },
  { year: "1972", title: "ACC Cement Dealership", text: "Awarded dealership of ACC Cement, marking the beginning of trusted brand partnerships." },
  { year: "1980", title: "Orient Cement Dealership", text: "Received dealership of Orient Cement Company, expanding product offering and market presence." },
  { year: "1990", title: "Kothapet Branch", text: "Inaugurated a new branch at Kothapet to expand operational presence across the city." },
  { year: "1992", title: "TATA Tiscon Dealership", text: "Awarded dealership by Samrat Group to supply TATA Tiscon TMT steel in Hyderabad." },
  { year: "2000", title: "TMT Revolution", text: "First in the city to shift focus from outdated TOR steel to modern TMT." },
  { year: "2000", title: "Strategic Transformation", text: "Discontinued cement trading to focus entirely on the growing TMT steel segment." },
  { year: "2008", title: "Nacharam Branch", text: "Inaugurated a new branch at Nacharam to extend reach into Secunderabad." },
  { year: "2013", title: "Karmanghat Branch", text: "Inaugurated a new branch at Karmanghat, Sagar Ring Road." },
  { year: "2015", title: "Operational Transition", text: "Shifted operations from Kothapet to Karmanghat office." },
  { year: "2020", title: "Digital Transformation", text: "Launched live price feeds and digital enquiry system through our website." },
  { year: "2021", title: "Katedan Branch", text: "Inaugurated a new branch at Katedan to broaden city-wide coverage." },
];

export const TEAM = [
  { initials: "SB", name: "Shyam Baheti", role: "Managing Director", bio: "Leads strategic purchasing and supplier relationships across operations." },
  { initials: "MB", name: "Manoj Baheti", role: "Managing Director", bio: "Oversees business operations, growth and management." },
  { initials: "GB", name: "Gaurav Baheti", role: "Management & Project Orders", bio: "Manages retail counters and ensures smooth customer servicing across branches." },
  { initials: "VB", name: "Vishal Baheti", role: "Retail Operations", bio: "Leads management operations and handles large-scale projects across India." },
  { initials: "YB", name: "Yash Baheti", role: "Stock & Accounts Management", bio: "Oversees inventory management, stock flow and payment operations." },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1761479867761-7a8b11f54449?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  "https://images.unsplash.com/photo-1763263385516-953ae09448f7?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  "https://images.pexels.com/photos/29824300/pexels-photo-29824300.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1300",
  "https://images.pexels.com/photos/10932215/pexels-photo-10932215.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1300",
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1600&q=85",
  "https://images.unsplash.com/photo-1581091870622-1c6a0f40a0b6?w=1600&q=85",
  "https://images.unsplash.com/photo-1565008576549-57569a49371d?w=1600&q=85",
  "https://images.unsplash.com/photo-1565514020179-026b92b84bb6?w=1600&q=85",
  "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=1600&q=85",
  "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1600&q=85",
  "https://images.unsplash.com/photo-1590725140246-20acdee442be?w=1600&q=85",
  "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=1600&q=85",
  "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1600&q=85",
  "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1600&q=85",
  "https://images.unsplash.com/photo-1503328427499-d92d1ac3d174?w=1600&q=85",
  "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?w=1600&q=85",
  "https://images.unsplash.com/photo-1503551723145-6c040742065b-v2?w=1600&q=85",
  "https://images.unsplash.com/photo-1581094271901-8022df4466f9?w=1600&q=85",
  "https://images.unsplash.com/photo-1597106776019-b4ecc878c202?w=1600&q=85",
  "https://images.unsplash.com/photo-1531973486364-5fa64260d75b?w=1600&q=85",
];

export const GRADES = [
  {
    code: "Fe 415",
    yieldStrength: "415 N/mm²",
    elongation: "14.5%",
    carbon: "≤ 0.30%",
    phosphorus: "≤ 0.055%",
    sulphur: "≤ 0.055%",
    use: "Low-rise residential & general purpose.",
  },
  {
    code: "Fe 500",
    yieldStrength: "500 N/mm²",
    elongation: "12%",
    carbon: "≤ 0.30%",
    phosphorus: "≤ 0.055%",
    sulphur: "≤ 0.055%",
    use: "High-rise buildings & RCC structures.",
  },
  {
    code: "Fe 550",
    yieldStrength: "550 N/mm²",
    elongation: "10%",
    carbon: "≤ 0.30%",
    phosphorus: "≤ 0.055%",
    sulphur: "≤ 0.055%",
    use: "Heavy infrastructure & industrial projects.",
  },
  {
    code: "Fe 600",
    yieldStrength: "600 N/mm²",
    elongation: "10%",
    carbon: "≤ 0.30%",
    phosphorus: "≤ 0.055%",
    sulphur: "≤ 0.055%",
    use: "Mega structures, bridges & specialized engineering.",
  },
];

export const FAQ = [
  { q: "Which TMT brands do you stock?", a: "We carry RADHA 550, SHREE, RADHA RHINO 600+, SARWOTTAM, JAIRAJ and TATA TMT." },
  { q: "What sizes of TMT rods are available?", a: "Standard 40 ft / 12 m rods (bent at 20 ft / 6 m) in 8 mm, 10 mm, 12 mm, 16 mm, 20 mm, 25 mm & 32 mm diameters." },
  { q: "How is pricing calculated?", a: "Pricing is per-kilogram at the brand rate. Our calculator uses D²/162 to estimate weight; you pay only for actual weight on our calibrated bridges." },
  { q: "Do you deliver to construction sites?", a: "Yes — we run an in-house fleet across Hyderabad & Secunderabad with same-day dispatch for stocked brands." },
  { q: "Can builders get credit terms?", a: "Established builder partners may qualify for credit terms. Submit an enquiry and our team will share the builder programme." },
  { q: "Do you supply MS angles, flats or binding wire?", a: "Our core focus is TMT. For secondary steel, speak to our team and we will guide you." },
];

// Standard diameters per BIS — used by calculator (Weight kg/m = D² / 162)
export const DIAMETERS = [8, 10, 12, 16, 20, 25, 32];
